module.exports = __webpack_public_path__ + "static/trabajando_02-c12262f803f20ef15937f0b49a8b6ecf.jpg";